<template>
    <div>
        <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" size="mini" :inline="false">
            <el-form-item class="form-title" prop="i_id" label="ERP ID" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.i_id" size="mini" placeholder="请输入"></el-input>
                <div class="mrA" v-else>{{formData.i_id}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_name" label="名称" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_name" size="mini" placeholder="请输入"></el-input>
                <div class="mrA" v-else>{{formData.vc_name}}</div>
            </el-form-item>
            <el-form-item prop="i_isuse" label="是否启用" style="width: 350px" v-if="data.i_id!=0">
                <el-radio-group v-model="formData.i_isuse" v-if="canEdit">
                    <el-radio  :label="1">是</el-radio>
                    <el-radio  :label="0">否</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.i_isuse==1?'是':'否'}}</div>
            </el-form-item>
<!--            <el-form-item class="form-title" prop="i_order" label="排序号" style="width: 350px" >-->
<!--                <el-input v-if="canEdit" v-model="formData.i_order" size="mini" placeholder="请输入"></el-input>-->
<!--                <div class="mrA" v-else>{{formData.i_order}}</div>-->
<!--            </el-form-item>-->
            <el-form-item class="form-title" prop="vc_lruname" label="录入人" style="width: 350px" >
                <div class="mrA" >{{formData.vc_lruname}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="dt_createtime" label="录入时间" style="width: 350px" >
                <div class="mrA" >{{formData.dt_createtime}}</div>
            </el-form-item>
        </el-form>
        <div  class="center">
                <el-button type="primary" @click="save('formData')" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";

    export default {
        name: "GsPage",
        components: {},
        props: {
            data:{
                type:Object,
                required: true,
                // default:()=>({})
            }
        },
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                formData:{
                    vc_name:'',
                    i_isuse:1,
                    i_id:'',
                },
                canEdit:false,
                disabled:false,
                bankList:[],
                rules:{
                    vc_name:[{required: true,message:'名称不能为空'}],
                    i_id:[{required: true,message:'ERP ID不能为空'}],

                    // i_isuse:[{required: true,message:'是否启用不能为空'}],
                }
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
            //data:{
            //     handler(){
            //         if(this.data.i_id==0){
            //             this.canEdit=true
            //             this.getbzlist();
            //             this.getDqList();
            //             this.now=this.$DateTime.now();
            //             this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
            //             this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
            //             this.formData.i_lruid=sessionStorage.getItem("userid");//renid
            //         }else{
            //             this.formData=JSON.parse(JSON.stringify(this.data))
            //         }
            //         console.log(this.data,'handler',this.formData)
            //
            //     },
            //     immediate:true,
            //     deep:true
            // },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.now=this.$DateTime.now();
            this.$nextTick(() => {
                this.onResize();
            });
            if(this.data.i_id==0){
                this.canEdit=true;
                // this.formData.i_id=0
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid
            }else{
                this.formData=JSON.parse(JSON.stringify(this.data))
            }
            // this.formData=JSON.parse(JSON.stringify(this.data));
            // console.log(this.data,'mounted',this.formData)


        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            cancel(){
                this.$emit('close')
            },
            save(formName){
                this.$refs[formName].validate((valid)=>{
                    if(valid){
                        if(this.data.i_id==0){
                            this.addSector()

                        }else{
                            this.editSector()
                        }
                    }else{
                        return false
                    }
                })
            },
            editForm(){
                this.canEdit=true
            },
            //新增
            async addSector(){
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid
                let param=this.formData;
                let res=await API.addSector(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.canEdit=false
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.canEdit=false
                }
            },
            //编辑
            async editSector(){
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid
                let param=this.formData;
                let res=await API.editSector(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.canEdit=false
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.canEdit=false
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .center{
        text-align: center;
    }
    /deep/{
        .el-form-item__content{
            width: calc(100% - 145px);
        }
        .el-select{
            margin-right: 0 !important;
            width: 100% !important;
        }
    }

</style>